import messages from '../../dataStore/constants/messageCodes'

export default function (code) {

  if (messages.hasOwnProperty(code)) return messages[code]

  return messages.default

}
